export default "__VITE_ASSET__BuT299Jh__"